import React from 'react';
import type MarketplaceType from '@jira/spa-apps__marketplace/src/MarketplaceShell.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyMarketplace: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof MarketplaceType
>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-marketplace", jiraSpaEntry: "async-marketplace" */ '@jira/spa-apps__marketplace/src/MarketplaceShell.tsx'
			),
		),
	{ ssr: false },
);

export const MarketplaceComponent = (): React.JSX.Element => (
	<LazyPage Page={LazyMarketplace} pageId="marketplace" shouldShowSpinner />
);
